import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { ArrowRightIcon } from 'assets/icons';
import { DescriptionText } from 'common/components/Breadcrumbs/Breadcrumbs.styled';
import { BackIcon } from 'common/utilities/Tabs/Tabs.styled';

export interface IBreadcrumbsProps {
  backTo?: string | (() => void | null);
  links: { label: string; link: string; customFn?: () => void }[];
  hideBackIcon?: boolean;
}

export const Breadcrumbs = ({ backTo, links, hideBackIcon }: IBreadcrumbsProps) => {
  const navigate = useNavigate();
  const { colors } = useTheme();

  return (
    <>
      {!hideBackIcon && (
        <BackIcon
          to="#"
          onClick={e => {
            e.preventDefault();

            if (typeof backTo === 'function') {
              backTo();
            } else if (backTo) {
              navigate(backTo);
            } else {
              navigate(-1);
            }
          }}
        >
          <ArrowRightIcon rotate={180} stroke={colors.black_60} />
        </BackIcon>
      )}

      {links.map(({ label, link, customFn }, index: number) => {
        const isLastItem = index < links.length - 1;

        return (
          <DescriptionText
            key={link + index}
            isLastItem={isLastItem}
            onClick={customFn ? customFn : () => navigate(link)}
          >
            {label}
          </DescriptionText>
        );
      })}
    </>
  );
};
